import React, { useState } from "react";
import { SetupDataPageTemplate } from "../../../components/setup-pages/SetupDataPageTemplate";
import { Field, Form, FieldError } from "react-jsonschema-form-validation";
import { setupData } from "../../../configs/routes";
import { finishSmokingHistory, pathRoot } from "../SmokingHistory";
import { FormValidator } from "../../../components/common/FormValidator";
import { Checkbox } from "../../../components/common/FormInputs";

export function Page2({ smokingHistory }) {
	const schema = {
		type: "object",
		properties: {
			smokingDuration: { type: "integer", minimum: 0, maximum: 100 },
		},
		required: ["smokingDuration"],
	};

	const [smokingDuration, setSmokingDuration] = useState(
		smokingHistory.smokingDuration
	);
	const [smokingTypes, setSmokingTypes] = useState(smokingHistory.smokingTypes);
	const [cigaretteAmount, setCigaretteAmount] = useState(
		smokingHistory.cigaretteAmount
	);
	const [formIsValid, setFormIsValid] = useState(false);

	const hideNext = () => {
		if (formIsValid) {
		} else {
			return true;
		}

		if (
			smokingTypes.length === 0 ||
			(smokingTypes.some((e) => e === 0) && cigaretteAmount === null)
		) {
			return true;
		}

		return false;
	};

	const onFinish = () => {
		smokingHistory.smokingDuration = smokingDuration;
		smokingHistory.smokingTypes = smokingTypes;

		if (smokingTypes.some((e) => e === 0)) {
			smokingHistory.cigaretteAmount = parseInt(cigaretteAmount);
		} else {
			smokingHistory.cigaretteAmount = null;
		}

		return finishSmokingHistory(smokingHistory);
	};

	const toggleSmokingType = (value) => {
		if (smokingTypes.some((e) => e === value)) {
			setSmokingTypes(smokingTypes.filter((e) => e !== value));
		} else {
			const temp = [...smokingTypes];
			temp.push(value);
			setSmokingTypes(temp);
		}
	};

	let cigaretteAmountElement = null;

	const isChecked = (value) => {
		return smokingTypes.some((e) => e === value);
	};

	if (smokingTypes.some((e) => e === 0)) {
		cigaretteAmountElement = (
			<>
				<p className={"text-lg sm:text-xl font-bold mb-6 mt-6 sm:mt-8"}>
					Over this period, on average how many cigarettes per day did you
					smoke?
				</p>
				<div className="radioSelect">
					<Field
						type="radio"
						name="cigaretteAmount"
						id="lessThan10"
						className={"hidden radioOption"}
						value={0}
						checked={cigaretteAmount === 0}
						onClick={() => setCigaretteAmount(0)}
					/>
					<Checkbox
						htmlFor={"lessThan10"}
						label={"Less than 10"}
						checked={cigaretteAmount === 0}
					/>

					<Field
						type="radio"
						name="cigaretteAmount"
						id="between1020"
						className={"hidden radioOption"}
						value={1}
						checked={cigaretteAmount === 1}
						onClick={() => setCigaretteAmount(1)}
					/>
					<Checkbox
						htmlFor={"between1020"}
						label={"Between 10-20"}
						checked={cigaretteAmount === 1}
					/>

					<Field
						type="radio"
						name="cigaretteAmount"
						id="between2040"
						className={"hidden radioOption"}
						value={2}
						checked={cigaretteAmount === 2}
						onClick={() => setCigaretteAmount(2)}
					/>
					<Checkbox
						htmlFor={"between2040"}
						label={"Between 20-40"}
						checked={cigaretteAmount === 2}
					/>

					<Field
						type="radio"
						name="cigaretteAmount"
						id="moreThan40"
						className={"hidden radioOption"}
						value={3}
						checked={cigaretteAmount === 3}
						onClick={() => setCigaretteAmount(3)}
					/>
					<Checkbox
						htmlFor={"moreThan40"}
						label={"More than 40"}
						checked={cigaretteAmount === 3}
					/>
				</div>
			</>
		);
	}

	const headerDetails = {
		title: "Smoking History",
		currentPage: 2,
		pageCount: 2,
	};

	const handleValidate = (value) => {
		setFormIsValid(value);
	};

	return (
		<>
			<SetupDataPageTemplate
				headerDetails={headerDetails}
				backTo={`${pathRoot}/1`}
				nextTo={setupData}
				onClickNext={{ func: onFinish, async: true }}
				hideNext={hideNext()}
				nextTextOverride={"Finish"}
			>
				<Form
					schema={schema}
					data={{
						smokingDuration: smokingDuration,
					}}
				>
					<div className={"mb-8 flex flex-col text-sm font-bold"}>
						<label
							className={"block text-lg sm:text-xl font-bold mb-3 sm:mb-6"}
							htmlFor={"smokingDuration"}
						>
							{smokingHistory.smoker === 0 ? (
								<>How many years have you smoked in total?</>
							) : (
								<>How many years did you smoke in total?</>
							)}
						</label>

						<div className={"w-1/2"}>
							<Field
								type="number"
								className={"formField"}
								id={"smokingDuration"}
								name="smokingDuration"
								value={smokingDuration || ""}
								onChange={(e) => {
									setSmokingDuration(parseInt(e.target.value));
								}}
							/>
							<FieldError
								errorMessages={{
									required: () => "You must enter a duration",
									maximum: () => "Cannot be more than 100 years",
									type: () => "Must be a whole number",
								}}
								name={"smokingDuration"}
								className={"rounded-b-sm"}
							/>
						</div>
					</div>
					<p className={"text-lg sm:text-xl font-bold mb-1 sm:mb-2"}>
						{smokingHistory.smoker === 0 ? (
							<>What type of smoking do you regularly do?</>
						) : (
							<>What type of smoking did you regularly do?</>
						)}
					</p>
					<p className={"mb-6"}>(select all that apply)</p>

					<div>
						<Field
							type="select"
							name="smokingType"
							id="smokingTypeCigarette"
							className={"hidden"}
							checked={isChecked(0)}
							onClick={() => toggleSmokingType(0)}
						/>
						<Checkbox
							htmlFor={"smokingTypeCigarette"}
							label={"Cigarette"}
							checked={isChecked(0)}
						/>

						<Field
							type="select"
							name="smokingType"
							id="smokingTypePipe"
							className={"hidden"}
							checked={isChecked(1)}
							onClick={() => toggleSmokingType(1)}
						/>
						<Checkbox
							htmlFor={"smokingTypePipe"}
							label={"Pipe"}
							checked={isChecked(1)}
						/>

						<Field
							type="select"
							name="smokingType"
							id="smokingTypeCigar"
							className={"hidden"}
							checked={isChecked(2)}
							onClick={() => toggleSmokingType(2)}
						/>
						<Checkbox
							htmlFor={"smokingTypeCigar"}
							label={"Cigar"}
							checked={isChecked(2)}
						/>
					</div>
					{cigaretteAmountElement}
					<FormValidator validateCallback={handleValidate} />
				</Form>
			</SetupDataPageTemplate>
		</>
	);
}
